

























































import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import EditIcon from "@/basics/icon/EditIcon.vue";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import EditModal from "@/components/modal/EditModal.vue";
import EditableText, { SaveEventHandler } from "@/containers/EditableText.vue";
import DeleteModal from "@/components/modal/DeleteModal.vue";
import SelectBooleanModal from "@/components/modal/SelectBooleanModal.vue";
import {
  GROUP_ONE,
  GroupOneData,
  GroupVariables
} from "@/graphql/query/group/one";
import { Scope, check, Scopes } from "@/lib/scope";

import { updateGroup } from "@/graphql/mutation/updateGroup";
import { USER_ME, UserData } from "@/graphql/query/user/me";

export interface Group {
  id: string;
  name: string;
  isPrivileged: boolean;
  allowRescueOperations: boolean;
}

@Component({
  components: {
    CButton,
    SimpleTable,
    EditModal,
    EditableText,
    DeleteModal,
    SelectBooleanModal,
    EditIcon
  },
  apollo: {
    group: {
      query: GROUP_ONE,
      variables(): GroupVariables {
        return { id: this.$apollo.vm.$route.params.groupId };
      },
      update(data: GroupOneData): Group {
        return data.group;
      }
    },
    me: USER_ME
  }
})
export default class GroupDetails extends Vue {
  me: UserData | null = null;
  remotePermitSelectModal: boolean = false;
  group: Group | null = null;
  groupOptions = [
    { text: "親グループ", value: "0" },
    { text: "子グループ", value: "1" }
  ];

  // グループ設定変更の権限(親組織管理者のみ・子グループに対しての操作)
  get changeGroupDataAllowed(): boolean {
    const allowed: Scopes<"Company"> = [
      {
        resource: "Company",
        resourceId: this.me!.company.id,
        action: "management"
      }
    ];
    return check(allowed, this.me!.scopes);
  }

  savegroupNameEvent(value: string, resolve: any, reject: any) {
    setTimeout(() => {
      this.group!.name = value;
      resolve();
    }, 2000);
  }

  remotePermitOptions = [
    { text: "許可する", value: true },
    { text: "許可しない", value: false }
  ];

  async saveName(handler: SaveEventHandler) {
    handler(async (value: string) => {
      // 保存
      await updateGroup(this.$apollo, {
        groupId: this.$apollo.vm.$route.params.groupId,
        name: value
      });

      // クエリ再取得
      await this.$apollo.queries.group.refresh();
    });
  }

  async saveRemotePermit(value: boolean) {
    try {
      // 保存
      await updateGroup(this.$apollo, {
        groupId: this.$apollo.vm.$route.params.groupId,
        allowRescueOperations: value
      });

      // クエリ再取得
      await this.$apollo.queries.group.refresh();
      this.remotePermitSelectModal = false;
    } catch {
      alert("保存に失敗しました");
      this.remotePermitSelectModal = false;
    }
  }
}
